<!-- فرم کدینگ اطلاعات -->
<template>
  <div class="row">
    <div class="col p-0">
      <!-- تب های سربرگ طبقه بندی عملیاتی -->
      <ul class="nav nav-tabs">
        <!-- تب طبقه بندی عملیاتی - پروژه -->
        <li class="nav-item activeNav rounded-top">
          <a
            href="#tabProject"
            id="home-tab"
            class="
              nav-link
              active
              d-flex
              justify-content-between
              align-items-center
            "
            data-toggle="tab"
          >
            طبقه بندی عملیاتی ( پروژه ها )
          </a>
        </li>
        <!-- تب طبقه بندی عملیاتی - خدمت -->
        <li class="nav-item rounded-top">
          <a
            href="#tabServing"
            id="profile-tab"
            class="nav-link d-flex justify-content-between align-items-center"
            data-toggle="tab"
          >
            طبقه بندی عملیاتی ( خدمت ها )
          </a>
        </li>
      </ul>
      <!-- پایان تب های سربرگ طبقه بندی عملیاتی -->

      <!-- بدنه محتویات طبقه بندی علمیاتی -->
      <div class="tab-content rounded shadow z-depth-1 p-1">
        <!-- تب طبقه بندی عملیاتی - پروژه -->
        <div class="tab-pane fade show active w-100" id="tabProject">
          <div class="row p-2">
            <!-- منوهای بالای جدول اصلی -->
            <div class="col-12 p-0">
              <div class="row p-0 d-flex justify-content-between align-items-center">
                <!-- جستجوی پیشرفته در لیست سرفصل حساب ها -->
                <div class="col-5 p-0 pb-2">
                  <div class="input-group p-0">
                    <input
                      id="textTabagheBandiSearch_Project"
                      placeholder="جستجو پیشرفته در لیست طبقه بندی علمیاتی (پروژه‌ها) (Enter)"
                      type="text"
                      class="form-control form-control-sm rounded-0"
                      v-on:focus="$event.target.select()"
                      v-on:keyup.enter="filterData_Project($event.target.value)"
                    />
                    <div class="input-group-prepend rounded-0">
                      <span
                        class="
                          input-group-text input-group-box-size
                          bg-secondary
                          rounded-left
                          white-text
                        "
                      >
                        <a v-on:click="filterData_Project('Search')">
                          <i class="fas fa-search"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- منوهای سمت چپ -->
                <div
                  class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center"
                >
                  <a
                    class="
                      btn btn-secondary btn-sm btn-floating
                      p-0
                      m-0
                      d-flex
                      justify-content-around
                      align-items-center
                    "
                    style="width: 120px; height: 30px"
                    title="ثبت ماموریت جدید"
                    data-toggle="modal" 
                    v-bind:data-target="'#ModalAddNewTabagheBandiAmaliyati-' + '0'"
                    v-on:click="ShowModalAddNewTabagheBandiAmaliyati"
                  >
                    <!-- v-on:click="addNewTab('AccDoc')" -->
                    ثبت ماموریت جدید
                    <i class="far fa-clone fa-1x-half text-white"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- جدول لیست طبقه بندی عملیاتی - پروژه ها  -->
            <ShowTableTabagheBandiAmaliyati
              :key="1"
              v-bind:ParentCode="0"
              v-bind:TabagheBandiType="1"
              v-bind:ListTabagheBandiAmaliyatiData="setListTabagheBandiAmaliyati_Project"
              v-bind:isMultieSelect="isMultieSelect"
              v-bind:ListAllShowFilter="ListTabagheBandiAmaliyati_Project_ShowFilter"
            ></ShowTableTabagheBandiAmaliyati>
            <!-- مودال ثبت طبقه بندی علمیاتی جدید - پروژه ی جدید -->
            <!-- <AddNewTabagheBandiAmaliyati
              v-bind:ParentCode="0"
              v-bind:NewChildCode="NewChildCode"
              v-bind:NPerType="4"
              v-bind:NPerName="'ماموریت'"
              v-bind:Title1="'ثبت ماموریت جدید'"
              v-bind:Title2="''"
              v-if="isShowModalAddNew"
            >
            </AddNewTabagheBandiAmaliyati> -->

          </div>
        </div>
        <!-- پایان تب طبقه بندی عملیاتی - پروژه -->

        <!-- تب طبقه بندی عملیاتی - خدمت -->
        <div class="tab-pane fade show w-100" id="tabServing">
          <div class="row p-2">
            <!-- منوهای بالای جدول اصلی -->
            <div class="col-12 p-0">
              <div class="row p-0 d-flex justify-content-between align-items-center">
                <!-- جستجوی پیشرفته در لیست سرفصل حساب ها -->
                <div class="col-5 p-0 pb-2">
                  <div class="input-group p-0">
                    <input
                      id="textTabagheBandiSearch_Serving"
                      placeholder="جستجو پیشرفته در لیست طبقه بندی علمیاتی (خدمت‌ها) (Enter)"
                      type="text"
                      class="form-control form-control-sm rounded-0"
                      v-on:focus="$event.target.select()"
                      v-on:keyup.enter="filterData_Serving($event.target.value)"
                    />
                    <div class="input-group-prepend rounded-0">
                      <span
                        class="
                          input-group-text input-group-box-size
                          bg-secondary
                          rounded-left
                          white-text
                        "
                      >
                        <a v-on:click="filterData_Serving('Search')">
                          <i class="fas fa-search"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- منوهای سمت چپ -->
                <div
                  class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center"
                >
                  <a
                    class="
                      btn btn-secondary btn-sm btn-floating
                      p-0
                      m-0
                      d-flex
                      justify-content-around
                      align-items-center
                    "
                    style="width: 120px; height: 30px"
                    title="ثبت ماموریت جدید"
                    data-toggle="modal" 
                    v-bind:data-target="'#ModalAddNewTabagheBandiAmaliyati-' + '0'"
                    v-on:click="ShowModalAddNewTabagheBandiAmaliyati"
                  >
                    <!-- v-on:click="addNewTab('AccDoc')" -->
                    ثبت ماموریت جدید
                    <i class="far fa-clone fa-1x-half text-white"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- جدول لیست طبقه بندی عملیاتی - خدمت ها  -->
            <ShowTableTabagheBandiAmaliyati
              :key="2"
              v-bind:ParentCode="0"
              v-bind:TabagheBandiType="2"
              v-bind:ListTabagheBandiAmaliyatiData="setListTabagheBandiAmaliyati_Serving"
              v-bind:isMultieSelect="isMultieSelect"
              v-bind:ListAllShowFilter="ListTabagheBandiAmaliyati_Serving_ShowFilter"
            ></ShowTableTabagheBandiAmaliyati>
          </div>
        </div>
        <!-- پایان تب طبقه بندی عملیاتی - خدمت -->
      </div>
      <!-- پایان بدنه محتویات طبقه بندی علمیاتی -->

      <!-- مودال ثبت طبقه بندی علمیاتی جدید - پروژه ی جدید -->
      <AddNewTabagheBandiAmaliyati
        v-bind:ParentCode="0"
        v-bind:NewChildCode="NewChildCode"
        v-bind:NPerType="4"
        v-bind:NPerName="'ماموریت'"
        v-bind:Title1="'ثبت ماموریت جدید'"
        v-bind:Title2="''"
        v-if="isShowModalAddNew"
      >
      </AddNewTabagheBandiAmaliyati>
    </div>
  </div>
</template>

<script>
import ShowTableTabagheBandiAmaliyati from "./Components/ShowTableTabagheBandiAmaliyati.vue";
import AddNewTabagheBandiAmaliyati from "./Components/AddNewTabagheBandiAmaliyati.vue";
// import { BusEvent } from "../../../../main.js";

export default {
  name: 'ListTabagheBandiAmaliyati',
  components: {
    ShowTableTabagheBandiAmaliyati,
    AddNewTabagheBandiAmaliyati
  },
  data() {
    return {
      // لیست اصلی پروژه های محلی
      ListTabagheBandiAmaliyati_Project: [],
      // لیست سطرهای پروژه در حال نمایش
      ListTabagheBandiAmaliyati_Project_ShowFilter: [],
      // لیست اصلی خدمت های محلی
      ListTabagheBandiAmaliyati_Serving: [],
      // لیست سطرهای خدمت در حال نمایش
      ListTabagheBandiAmaliyati_Serving_ShowFilter: [],
      // کد سرفصل حساب جدید
      NewChildCode: 0,
      // کنترل وضعیت چند انتخابی
      isMultieSelect: true,
      // کنترل وضعیت نمایش مودال ثبت جدید
      isShowModalAddNew: false
    };
  },
  created() {
      this.getListTabagheBandiAmaliyati();
  },
  computed: {
    setListTabagheBandiAmaliyati_Project(){
      // نوع : 1 پروژه ها - 2 خدمت ها
      this.ListTabagheBandiAmaliyati_Project = this.$store.getters.getListTabagheBandiAmaliyati(1);
      return this.ListTabagheBandiAmaliyati_Project;
    },
    setListTabagheBandiAmaliyati_Serving(){
      // نوع : 1 پروژه ها - 2 خدمت ها
      this.ListTabagheBandiAmaliyati_Serving = this.$store.getters.getListTabagheBandiAmaliyati(2);
      return this.ListTabagheBandiAmaliyati_Serving;
    }
  },
  methods: {
    // استخراج لیست طبقه بندی علمیاتی
    async getListTabagheBandiAmaliyati() {
      // دریافت اطلاعات کاربر جاری
      let token = await this.$store.getters.getUserData.token; // توکن کاربر
      let NYear = await this.$store.getters.getYearActive; // دریافت سال فعال
      // دریافت لیست حساب ها
      await this.$store.dispatch("getTabagheBandiAmaliyatiFromSever", {
        NYear,
        token,
      });
    },

    // نمایش مودال درج سرفصل حساب جدید
    ShowModalAddNewTabagheBandiAmaliyati(){
      this.NewChildCode = this.getLastChildCode_Project();
      if(this.NewChildCode > 9){
        // سقف ماموریت ها تکمیل شده است
        // مجاز به ثبت ماموریت جدید نمی باشید
        // بستن مودال ثبت طبقه بندی جدید
        this.isShowModalAddNew = false;
        swal({
          title: "تکمیل سقف ماموریت ها",
          text: "سقف تعریف ماموریت ها در سال جاری تکمیل شده است .\nشما مجاز به تعریف ماموریت جدید نمی باشید .",
          icon: "info", // success, warning, error, info
          buttons: {
            // cancel: "متوجه شدم",
            ok: "بله متوجه شدم",
          },
        });
      } else {
        this.isShowModalAddNew = true;
      }
    },

    // استخراج کد آخرین فرزند جهت درج سطر جدید
    getLastChildCode_Project(){
      let tempCode = 0;
      this.getListChildLevel1_Project().forEach(element => {
        if(element.SPerNationalId > tempCode){
          tempCode = element.SPerNationalId
        }
      });
      if(parseInt(tempCode) > 0){
        // افزایش یک واحدی کد آخرین فرزند
        return (parseInt(tempCode) + 1).toString();
      } else {
        // فرزندی یافت نشد / صدور کد جدید / ماموریت 1
        return '1';
      }
    },
    // استخراج فرزندان سطح یک
    getListChildLevel1_Project() {
      let tempData = [];
      if (this.ListTabagheBandiAmaliyati_Project.length > 0) {
        // ماموریت
        tempData = this.ListTabagheBandiAmaliyati_Project.filter(function (item) {
          return item.SPerNationalId.toString().length == 1;
        });
      }
      return tempData;
    },    

    // جستجو در لیست طبقه بندی عملیاتی - پروژه ها
    filterData_Project(searchValue, event) {
      // اگر دکمه جستجو کلیک شود
      if (searchValue === "Search") {
        searchValue =
          $("#textTabagheBandiSearch_Project").val() != ""
            ? $("#textTabagheBandiSearch_Project").val()
            : "";
      }

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        let ListTabagheBandiFilter =
          this.ListTabagheBandiAmaliyati_Project.filter(function(item){
            return (
                item.SPerNationalId.toString().startsWith(searchValue) ||
                item.NPerLastName.toString().includes(searchValue)
              )
            });
        if(ListTabagheBandiFilter.length > 0){
          // نمایش پیام تعداد جستجو
          this.$store.dispatch("notify", {
            notText: "به تعداد ( " + ListTabagheBandiFilter.length + " ) مورد پیدا شد .",
            color: "86ff3b",
            timeOut: 2500,
          });
          // ایجاد لیست سطرهای انتخاب شده و در حال نمایش
          this.ListTabagheBandiAmaliyati_Project_ShowFilter.length = 0  // خالی کردن لیست سطرهای در حال نمایش
          // متغییر محلی لیست سطرهای در حال نمایش
          let tempListShow = [];
          // متغییر محلی معادل لیست سرفصل ها
          let tempListTabagheBandi = this.ListTabagheBandiAmaliyati_Project;  
          // اجرای حلقه به تعداد سطرهای جستجو شده
          ListTabagheBandiFilter.forEach(function(item){
            // استخراج تمام والدهای کد جستجو شده
            let listTemp = tempListTabagheBandi.filter(function(value){
              // اگر کد برابر بود یا ابتدای کد برابر بود
              return value.SPerNationalId == item.SPerNationalId || 
              item.SPerNationalId.toString().startsWith(value.SPerNationalId)
            });
            // استخراج کد تمام والدها
            listTemp.forEach(function(val) { 
                if(tempListShow.findIndex((find) => find == val.SPerNationalId) == -1){
                  tempListShow.push(val.SPerNationalId)
                }
              });
          });

          this.ListTabagheBandiAmaliyati_Project_ShowFilter = tempListShow;
          console.log(this.ListTabagheBandiAmaliyati_Project_ShowFilter);
        } else {
          this.$store.dispatch("notify", {
            notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
            timeOut: 2500,
          });
        }
      } 
    },

    // جستجو در لیست طبقه بندی عملیاتی - خدمت ها
    filterData_Serving(searchValue, event) {
      // اگر دکمه جستجو کلیک شود
      if (searchValue === "Search") {
        searchValue =
          $("#textTabagheBandiSearch_Serving").val() != ""
            ? $("#textTabagheBandiSearch_Serving").val()
            : "";
      }

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        let ListTabagheBandiFilter =
          this.ListTabagheBandiAmaliyati_Serving.filter(function(item){
            return (
                item.SPerNationalId.toString().startsWith(searchValue) ||
                item.NPerLastName.toString().includes(searchValue)
              )
            });
        if(ListTabagheBandiFilter.length > 0){
          // نمایش پیام تعداد جستجو
          this.$store.dispatch("notify", {
            notText: "به تعداد ( " + ListTabagheBandiFilter.length + " ) مورد پیدا شد .",
            color: "86ff3b",
            timeOut: 2500,
          });
          // ایجاد لیست سطرهای انتخاب شده و در حال نمایش
          this.ListTabagheBandiAmaliyati_Serving_ShowFilter.length = 0  // خالی کردن لیست سطرهای در حال نمایش
          // متغییر محلی لیست سطرهای در حال نمایش
          let tempListShow = [];
          // متغییر محلی معادل لیست سرفصل ها
          let tempListTabagheBandi = this.ListTabagheBandiAmaliyati_Serving;  
          // اجرای حلقه به تعداد سطرهای جستجو شده
          ListTabagheBandiFilter.forEach(function(item){
            // استخراج تمام والدهای کد جستجو شده
            let listTemp = tempListTabagheBandi.filter(function(value){
              // اگر کد برابر بود یا ابتدای کد برابر بود
              return value.SPerNationalId == item.SPerNationalId || 
              item.SPerNationalId.toString().startsWith(value.SPerNationalId)
            });
            // استخراج کد تمام والدها
            listTemp.forEach(function(val) { 
                if(tempListShow.findIndex((find) => find == val.SPerNationalId) == -1){
                  tempListShow.push(val.SPerNationalId)
                }
              });
          });

          this.ListTabagheBandiAmaliyati_Serving_ShowFilter = tempListShow;
          console.log(this.ListTabagheBandiAmaliyati_Serving_ShowFilter);
        } else {
          this.$store.dispatch("notify", {
            notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
            timeOut: 2500,
          });
        }
      } 
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListTabagheBandiAmaliyati/ListTabagheBandiAmaliyati.vue